import {
  RadioButton as CXRadioButton,
  RadioButtonGroup as CXRadioButtonGroup
} from '@sanlamcx/react-ui-next-radio-button';

type RadioButton = typeof CXRadioButton;
export const RadioButton: RadioButton = CXRadioButton;

type RadioButtonGroup = typeof CXRadioButtonGroup;
export const RadioButtonGroup: RadioButtonGroup = CXRadioButtonGroup;
